import { Center, Loader, PinInput, Stack } from "@mantine/core"
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../../utils/form-submission-notifications"
import { useInvalidate } from "../../../typed-client/hooks/use-invalidate"
import { FormButtonGroup } from "../../../-components/form-button-group"
import { CancelButton, SubmitButton } from "../../../-components/Buttons"
import { useTranslation } from "react-i18next"
import { usePostMutation } from "../../../typed-client/hooks/use-post-mutation"
import { useForm } from "@mantine/form"
import { ValidateTotpRequest } from "../../../@client/Theasoft_ApiServer_UserAuthenticationFactors"

interface Props {
  userAuthenticationFactorId: number
  onSuccess: () => void
  onCancel: () => void
}

export function ValidateCodeForm({
  userAuthenticationFactorId,
  onSuccess,
  onCancel,
}: Props) {
  const invalidate = useInvalidate()
  const { t } = useTranslation("app_server")
  const validateCode = usePostMutation(
    "/api/UserAuthenticationFactor/ValidateCode",
    {
      onSuccess: () => {
        invalidate("/api/UserAuthenticationFactor/GetUserAuthenticationFactors")
        showSuccessNotification(t("Success"))
        onSuccess()
      },
      onError: showErrorNotification,
    }
  )
  const form = useForm<ValidateTotpRequest>({
    initialValues: { userAuthenticationFactorId, code: "" },
    mode: "uncontrolled",
  })
  const handleSubmit = async (values: ValidateTotpRequest) =>
    await validateCode.mutateAsync(values)

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack>
        <Center>
          <Stack>
            <PinInput
              autoFocus
              type="number"
              length={6}
              onComplete={() => handleSubmit(form.getValues())}
              key={form.key("code")}
              {...form.getInputProps("code")}
            />
          </Stack>
        </Center>
        <FormButtonGroup>
          <CancelButton onClick={onCancel} />
          <SubmitButton
            disabled={validateCode.isPending || validateCode.isSuccess}
          >
            {validateCode.isPending ? <Loader /> : t("Confirm")}
          </SubmitButton>
        </FormButtonGroup>
      </Stack>
    </form>
  )
}
